var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRelation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2146 19.2146C19.5563 18.8729 20.1103 18.8729 20.4521 19.2146L25.1187 23.8813C25.4604 24.223 25.4604 24.777 25.1187 25.1187C24.777 25.4604 24.223 25.4604 23.8813 25.1187L19.2146 20.4521C18.8729 20.1103 18.8729 19.5563 19.2146 19.2146Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8333 4.375C8.16192 4.375 4.375 8.16192 4.375 12.8333C4.375 17.5047 8.16192 21.2917 12.8333 21.2917C15.1733 21.2917 17.29 20.3426 18.8222 18.8063C20.3492 17.2753 21.2917 15.1652 21.2917 12.8333C21.2917 8.16192 17.5047 4.375 12.8333 4.375ZM2.625 12.8333C2.625 7.19543 7.19543 2.625 12.8333 2.625C18.4712 2.625 23.0417 7.19543 23.0417 12.8333C23.0417 15.6472 21.9021 18.1965 20.0613 20.0421C18.2142 21.8941 15.6569 23.0417 12.8333 23.0417C7.19543 23.0417 2.625 18.4712 2.625 12.8333Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRelation);
export default __webpack_public_path__ + "static/media/no-relation.b029c4f747f291509dd3c6bf06c2dffc.svg";
export { ForwardRef as ReactComponent };